/* eslint-disable no-unused-vars */
export enum SettingsCourseView {
  Tree = 'tree',
  Roadmap = 'roadmap'
}
